import type { Module } from '@/types/artwork/generate';
import { useUserStore } from '@/store/user';
import { Tag } from '@/types/prompt';

const userCustomKey = 'userSmartPromptFinishModalNotTip';

// 已经完成但是没有点开的智能提示词模块
interface ModuleState {
  module: Module;
  value: string | Tag[];
}
let moduleList:ModuleState[] = [];

let notTip = false; // 生图时不用再次
let initNotTip = false;

// 获取用户是否不再提示弹窗
async function getUserTipModalStatus() {
  if (!initNotTip) {
    const userStore = useUserStore();
    const { data } = await userStore.getCustom(userCustomKey);
    notTip = !!data;

    initNotTip = true;
  }
}

export function useSmartPromptFinishModule() {
  function getIndex(module: Module) {
    const index = moduleList.findIndex(item => item.module === module);

    return index;
  }

  async function has(module: Module) {
    await getUserTipModalStatus();

    // 不再提示
    if (notTip) {
      return false;
    }

    return getIndex(module) > -1;
  }

  function add(module: Module, value: string | Tag[]) {
    moduleList.push({
      module,
      value
    });
  }

  function del(module: Module) {
    const index = getIndex(module);

    if (index > -1) {
      moduleList.splice(index, 1);
    }
  }

  function clear(module?: Module) {
    if (module) {
      moduleList = moduleList.filter(item => item.module !== module);
    } else {
      moduleList = [];
    }
  }

  // 获取模块最新的内容
  function getLatest(module: Module) {
    const arr = moduleList.reverse();
    const index = arr.findIndex(item => item.module === module);

    if (index > -1) {
      const value = arr[index].value;

      clear(module);
      return value;
    }
  }

  // 设置不再提示
  function setNotTip() {
    const userStore = useUserStore();
    userStore.setCustom({
      key: userCustomKey,
      value: true
    });

    notTip = true;
  }

  return {
    add,
    del,
    has,
    clear,
    getLatest,
    setNotTip
  }
}